//WEEKLY BULLETIN PAGE
//*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE 
//import $ from 'jquery'
//import Popper from 'popper.js'
import React from 'react'
import {graphql} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../components/heading'
import Navbar from '../components/navbar'
import Footer from '../components/footer'
import PageHeader from '../components/PageHeader'
//import TableOfContents from '../components/TableOfContents'
//import PDFUpload from '../components/PDFUpload'
//import ContentBlock from  '../components/ContentBlock'
//import TextBlock from '../components/textblock'
//import Header from '../components/Header'
//import ContentList from '../components/ContentList'
//import ContentGridNew from '../components/ContentGridNew'
//import BodySection from '../components/BodySection'
//import ContentsTable from '../components/ContentsTable'
import Iframe from 'react-iframe'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const weeklyBulletinPage = ({data}) => {
    
    const weeklyBulletin = data.weekly_bulletin.edges
    
    return (   
        
        <div>
            
            <Helmet>
            <title>NJCCIC Weekly Bulletin</title>
             <meta name="description" content="Read the NJCCIC weekly bulletin sharing the lastest cyber security information"/>
			<link rel="stylesheet" href="../styles/mega-menu.css" />
            </Helmet>
            <Heading/>
            
            <Navbar/>
        
            {weeklyBulletin.map(({node: {page_title, url} }) => (
    
                <div class="container-fluid">
        
                    <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>
        
                     <div class="container-fluid">
                
                        <div class="container containerWidth">
        
                            <Iframe src={url}
                            width="100%"
                            height="10000px"
                            id="myId"
                            className="iframeBlock iframeBulletin"
                            display="initial"
                            position="relative"/>
        
                        </div>
        
                    </div>
                       
                </div>
            
            ))}
        
            <Footer/>
                
            
        </div> 

    )   
    
}
//*******************************************************************
//******************************************************************* 
export const query = graphql`
    query {
        weekly_bulletin: allButterPage(filter: {slug: { eq: "weekly-bulletin" } }) {
            edges {
                node {
                    slug
                    seo_title
                    page_title 
                    url
                }
            }
        }
       
    }
`
export default weeklyBulletinPage
//******************************************************************* 